import { PriceType, ResponseType } from '../Types/Prices';
import { customHeaders } from './CustomHeader';
import { apiBaseUrl } from './PortalAuthServices';

const REQUEST_TIMEOUT_MS = 30_000;
const SESSION_EXPIRED_MESSAGE = 'Oturum süreniz sona ermiş! Lütfen tekrar giriş yapın.';

async function postPortal(endpoint: string, body: unknown, headers: Record<string, string> = customHeaders): Promise<ResponseType> {
    const controller = new AbortController();
    let timedOut = false;
    const timeout = window.setTimeout(() => {
        timedOut = true;
        controller.abort();
    }, REQUEST_TIMEOUT_MS);

    try {
        const response = await fetch(`${apiBaseUrl}${endpoint}`, {
            method: 'POST',
            headers,
            body: JSON.stringify(body),
            signal: controller.signal,
        });

        if (response.status === 401) {
            return { error: true, message: SESSION_EXPIRED_MESSAGE, failureKind: 'unauthorized' };
        }

        if (!response.ok) {
            return {
                error: true,
                message: `Sunucu isteği tamamlayamadı (${response.status}). Lütfen yeniden deneyin.`,
                failureKind: 'server',
            };
        }

        try {
            const result: unknown = await response.json();
            if (!result || typeof result !== 'object' || !('error' in result) || !('message' in result)) {
                throw new Error('Unexpected response shape');
            }
            return result as ResponseType;
        } catch {
            return {
                error: true,
                message: 'Sunucudan geçerli bir yanıt alınamadı. İşlem durumunu listeyi yenileyerek kontrol edin.',
                failureKind: 'invalid_response',
            };
        }
    } catch (error) {
        if (timedOut || (error && typeof error === 'object' && 'name' in error && error.name === 'AbortError')) {
            return {
                error: true,
                message: 'İstek zaman aşımına uğradı. İşlem sunucuda tamamlanmış olabilir; tekrar göndermeden önce listeyi yenileyip kontrol edin.',
                failureKind: 'timeout',
            };
        }

        return {
            error: true,
            message: 'Sunucuya ulaşılamadı. Bağlantınızı kontrol edip işlem durumunu listeyi yenileyerek doğrulayın.',
            failureKind: 'network',
        };
    } finally {
        window.clearTimeout(timeout);
    }
}

async function GetList(companyId: string, token: string): Promise<ResponseType> {
    return postPortal('/fiyatonay/getlist', { companyId }, {
        ...customHeaders,
        Authorization: `Bearer ${token}`,
    });
}

async function ApprovePrice(companyId: string, content: PriceType, token: string): Promise<ResponseType> {
    return postPortal('/fiyatonay/approve', {
        companyId,
        serial: content.Serial,
        number: content.Number,
    }, {
        ...customHeaders,
        Authorization: `Bearer ${token}`,
    });
}

async function DeletePrice(companyId: string, content: PriceType, token: string): Promise<ResponseType> {
    return postPortal('/fiyatonay/delete', {
        companyId,
        serial: content.Serial,
        number: content.Number,
    }, {
        ...customHeaders,
        Authorization: `Bearer ${token}`,
    });
}

export { GetList, DeletePrice, ApprovePrice };
